module.exports = __webpack_public_path__ + "toBride1-we-g-b.f31c1256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-g-b.jpg
// module id = kS3w
// module chunks = 0